import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  centsToDollars,
  dollarsToCents,
  removeReadOnlyFields,
} from 'src/utils/fieldNormalizers';

import {
  Coupon,
  CouponSearchResult,
  PurchaseCoupon,
  SubscriptionCoupon,
} from './_types';

export const normalizeCouponSearchResult = (
  result: CouponSearchResult
): Partial<Coupon> => {
  const { discountType, limitPerUser, displayText, firstPurchaseOnly } =
    result.data.json;

  return {
    id: result.id,
    code: result.term,
    description: result.aliases?.join(', ') || '',
    discountType,
    limitPerUser,
    displayText,
    firstPurchaseOnly,
  };
};
const readOnlyFields = [
  'sellable_ids',
  'amount_in_dollars',
  'discount_type',
  'discount',
  'code',
];

const purchaseReadonlyFields = [
  'sellable_ids',
  'id',
  'created_at',
  'last_used',
  'trainer_id',
  'updated_at',
  'uses',
  'duration',
  'duration_in_months',
];

export const normalizeSubscriptionCoupon = (
  coupon: any
): SubscriptionCoupon => {
  const camelized = camelcaseKeys(coupon, {
    deep: true,
  });

  if (camelized.amountOff) {
    camelized.amountOff = centsToDollars(camelized.amountOff);
  }

  if (camelized.redeemBy) {
    camelized.redeemBy = new Date(camelized.redeemBy * 1000);
  }

  return camelized;
};

export const denormalizeSubscriptionCoupon = (
  coupon: Partial<SubscriptionCoupon>
) => {
  const decamelized = decamelizeKeys(coupon, {
    deep: true,
  });

  removeReadOnlyFields(decamelized, readOnlyFields);

  if (decamelized.amount_off) {
    decamelized.amount_off = dollarsToCents(decamelized.amount_off);
  }

  if (decamelized.redeem_by) {
    decamelized.redeem_by = Math.floor(
      new Date(decamelized.redeem_by).getTime() / 1000
    );
  }

  return decamelized;
};

export const normalizeStripeCoupon = (coupon: any): Coupon => {
  const camelized = camelcaseKeys(coupon, {
    deep: true,
  });

  return camelized;
};

export const denormalizePurchaseCoupon = (coupon: any): PurchaseCoupon => {
  const decamelized = decamelizeKeys(coupon, {
    deep: true,
  });

  removeReadOnlyFields(decamelized, purchaseReadonlyFields);

  // Handle date conversion for expires_on
  if (decamelized.expires_on && decamelized.expires_on instanceof Date) {
    decamelized.expires_on = decamelized.expires_on.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }

  return decamelized;
};

export const normalizePurchaseCoupon = (coupon: any): PurchaseCoupon => {
  const camelized = camelcaseKeys(coupon, {
    deep: true,
  });

  return camelized;
};
